module.exports = __webpack_public_path__ + "static/media/PM81.c8fba5c3.png";